import { render } from "./IntegratedCountHeading.vue?vue&type=template&id=0d29b2c5&scoped=true"
import script from "./IntegratedCountHeading.vue?vue&type=script&lang=js"
export * from "./IntegratedCountHeading.vue?vue&type=script&lang=js"

import "./IntegratedCountHeading.vue?vue&type=style&index=0&id=0d29b2c5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d29b2c5"]])

export default __exports__